export default "__VITE_ASSET__BFrr$WI1__"